import { nanoid } from 'nanoid';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ChecklistForm } from 'src/Components/Forms/Checklist/ChecklistForm';
import { useCreateChecklistForm } from 'src/Hooks/Forms/useCreateChecklistForm';
import { useCreateChecklist } from 'src/Hooks/Mutations/useCreateChecklist';

import { Props } from './ChecklistCreationFormWrapper.types';

const ChecklistCreationFormWrapper = ({ onCreate, onCancel, template }: Props) => {
  const { form, addItem, removeItem, reorderItems } = useCreateChecklistForm();
  const { mutate } = useCreateChecklist({ onSuccess: () => onCreate() });
  const { t } = useTranslation();

  useEffect(() => {
    if (template) {
      form.setValues({
        title: template.title,
        items: template.items.map(label => ({ label, localId: nanoid() })),
        icon: template.icon,
        color: template.color,
        templateKey: template.key,
      });
    }
  }, [template]);

  return (
    <ChecklistForm
      onCancel={onCancel}
      form={form}
      onSubmit={form.onSubmit(values => {
        mutate(values);
      })}
      submitButtonLabel={t('checklist.form.add', 'Enregistrer la checklist')}
      addItem={addItem}
      removeItem={removeItem}
      reorderItems={reorderItems}
    />
  );
};

export default ChecklistCreationFormWrapper;
